// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 公共样式
import './css/publicStyle.css'
//修改vant-ui样式
import './css/setDefaultVant.scss'
import 'lib-flexible/flexible'
// 需要用到mintui的省市区联调
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { Cascader } from 'vant'
import visibleDirective from './directive/index'


// 埋码
import { buryCode, buryCodeFun } from "@/public/buryCode"
//工具
import { getYYYYMMDD, getStrFromStr} from "./tools";
Vue.use(MintUI)

Vue.use(Cascader)

Vue.use(visibleDirective)

Vue.config.productionTip = false
// 具体的埋码
Vue.prototype.$buryCode = buryCode
// 具体调用埋码的方法
Vue.prototype.$buryCodeFun = buryCodeFun
// 加载js
Vue.prototype.$loadJs = function (url, callback,inWindowObj) {
  let fn = callback || function () { };
  if(inWindowObj){
    if(window[inWindowObj]){
      fn()
      return false
    }
  }
  let script = document.createElement('script');
  script.type = 'text/javascript';
  //IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    //其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
// 服务器图片路径
Vue.prototype.$aliUrl = 'https://staticcdn.yunheit.com/icardfront_hn/static';//'https://static.yunheit.com/icardfront_hn/static'
//工具
Vue.prototype.$getYYYYMMDD = getYYYYMMDD;
Vue.prototype.$getStrFromStr = getStrFromStr;
// axios.defaults.baseURL = '/api'
window.onresize = setHtmlFontSize
function setHtmlFontSize () {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDom = document.getElementsByTagName('html')[0]
  htmlDom.style.fontSize = htmlWidth / 10 + 'px'
};
setHtmlFontSize()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})  



// WEBPACK FOOTER //
// ./src/main.js